import { render, staticRenderFns } from "./pbrListForm.vue?vue&type=template&id=20d51847"
import script from "./pbrListForm.vue?vue&type=script&lang=js"
export * from "./pbrListForm.vue?vue&type=script&lang=js"
import style0 from "./pbrListForm.vue?vue&type=style&index=0&id=20d51847&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports